import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';

interface ScreenHeaderProps {
  title: string;
  subtitle?: ReactNode;
  onBack: () => void;
  backLabel?: string;
  actions?: ReactNode;
}

/** Stack / detail screens with back navigation */
export function ScreenHeader({
  title,
  subtitle,
  onBack,
  backLabel = 'Назад',
  actions,
}: ScreenHeaderProps) {
  return (
    <div className="flex items-start gap-3 min-w-0 mb-4 md:mb-6">
      <button
        type="button"
        onClick={onBack}
        className="btn-ghost w-10 h-10 shrink-0 surface-solid !p-0 md:w-11 md:h-11"
        aria-label={backLabel}
      >
        <ArrowLeft size={20} />
      </button>
      <div className="min-w-0 flex-1">
        <h1 className="page-title break-words min-h-10 md:min-h-11 flex flex-col justify-center">
          {title}
        </h1>
        {subtitle ? <div className="mt-1">{subtitle}</div> : null}
      </div>
      {actions ? (
        <div className="flex items-center gap-1 shrink-0 min-h-10 md:min-h-11">{actions}</div>
      ) : null}
    </div>
  );
}
